// extracted by mini-css-extract-plugin
module.exports = {"ant-spin-container":"LeaderboardPage_ant-spin-container__36ECj","PlaylistPage":"LeaderboardPage_PlaylistPage__1c4X5","scrollContainer":"LeaderboardPage_scrollContainer__Q4owX"};